export const MY_PORTAL_NOTIFICATION_QUERY_PARAM = 'notification'

const MY_PORTAL_NOTIFICATIONS = ['accountVerified', 'passwordSet'] as const

export type MyPortalNotification = typeof MY_PORTAL_NOTIFICATIONS[number]

export function isMyPortalNotification(value: string | null): value is MyPortalNotification {
  return MY_PORTAL_NOTIFICATIONS.includes(value as MyPortalNotification)
}
